import { createSelector } from 'reselect';

import { resourceTypes } from '../provisionQualitySinglePage/provisionQualitySingle.constants';

export const totalProvisionQuality = state => {
  const totalProvisionQuality = state.dashboard.provisionQuality.totalProvisionQuality;

  if (!totalProvisionQuality) {
    return {
      totalSuccess: 0,
      totalReady: 0,
      successPercent: 0,
    };
  }

  return totalProvisionQuality;
};

export const usefulStats = state => {
  const usefulStats = state.dashboard.provisionQuality.usefulStats;

  if (!usefulStats) {
    return {
      stat1: { stat: '', value: '' },
      stat2: { stat: '', value: '' },
      stat3: { stat: '', value: '' },
    };
  }

  return {
    stat1: { stat: '', value: '' },
    stat2: { stat: '', value: '' },
    stat3: { stat: '', value: '' },
    ...usefulStats,
  };
};

export const selectResourcesForSelect = createSelector(
  [
    state => state.shared.connections,
    state => state.dashboard.provisionQualitySingle.resourceType,
    state => state.dashboard.provisionQualitySingle.businessCodes,
  ],
  (connections, resourceType, businessCodes) => resourceType === resourceTypes.connection
    ? connections.map(({ connName }) => ({ value: connName, label: connName }))
    : businessCodes.map(({ businessCode, businessDescription }) => ({
      value: businessCode,
      label: businessDescription,
    }))
);

export const selectSelectedResource = createSelector(
  [
    state => state.shared.connection,
    state => state.dashboard.provisionQualitySingle.resourceType,
    state => state.dashboard.provisionQualitySingle.businessCode,
  ],
  (connection, resourceType, businessCode) => {
    if (resourceType === resourceTypes.connection) {
      return connection
        ? {
          name: connection.connName,
          value: connection.connName,
        }
        : null;
    }

    return businessCode
      ? {
        name: businessCode.businessDescription,
        value: businessCode.businessCode,
      }
      : null;
  }
);

export const connectionsOverallStatus = ({ dashboard }) => {
  const overallStatus = dashboard.connectionRunStatus.connectionsOverallStatus;

  return overallStatus ? overallStatus : {
    greenConnectionsPercents: 0,
    greenConnectionsCount: 0,
    totalConnectionsCount: 0,
  };
};

export const connectionsMonitorDataLoading = ({ dashboard }) =>
  dashboard.connectionRunStatus.connectionsMonitorDataLoading;

export const selectProvisionQualityLoading = ({ dashboard }) =>
  dashboard.provisionQualitySingle.provisionQualityLoading;

export const selectHeartbeatStatus = ({ dashboard }) => {
  const heartbeatStatus = dashboard.connectionRunStatus.heartbeatMonitorStatus;

  const statusResult = heartbeatStatus.find(status => status.statusFlag === 'N') ? 0 : 1;

  return [{ heartbeatStatus: statusResult }];
};

export const selectHeartbeatStatusLoading = ({ dashboard }) =>
  dashboard.connectionRunStatus.heartbeatMonitorStatusLoading;
